// extracted by mini-css-extract-plugin
module.exports = {"root":"NoStyleButton__root--1TOIe","noFocus":"NoStyleButton__noFocus--1qnss","bounce":"NoStyleButton__bounce--3-Foy"};